import Controller from "./country.controller";
import template from "./country.html";

const country = {
  template,
  controller: Controller,
};

export default country;



// WEBPACK FOOTER //
// ./src/pages/country/country.component.js